var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 960,
    height: 464,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 597.554,
    height: 396.861,
    x: 0,
    y: 0,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 331,
    height: 184,
    x: 0,
    y: 0,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "h",
    width: 167,
    height: 341,
    x: 0,
    y: 0,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "i",
    width: 155,
    height: 330,
    x: 0,
    y: 0,
    rx: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "k",
    width: 140,
    height: 184,
    x: 0,
    y: 0,
    rx: 5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: "213.8%",
    height: "155.7%",
    x: "-53.3%",
    y: "-16.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 40,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.243459558 0 0 0 0 0.279312558 0 0 0 0 0.375398597 0 0 0 0.255293252 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M3 0h769.629a3 3 0 013 3v16.006H0V3a3 3 0 013-3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(184 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 635,
    height: 434,
    x: 81,
    fill: "#191D36",
    fillRule: "nonzero",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 629,
    height: 428,
    x: 84,
    y: 3,
    fill: "#0B0E21",
    fillRule: "nonzero",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 603,
    height: 402,
    x: 97,
    y: 16,
    fill: "#16171B",
    fillRule: "nonzero",
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EBEDF4",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(129 14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 75)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 47,
    fill: "#FFF",
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 5,
    fill: "#B1B4C7",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 5,
    y: 9,
    fill: "#D4D7E6",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 5,
    fill: "#B1B4C7",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 5,
    y: 9,
    fill: "#D4D7E6",
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 5,
    fill: "#B1B4C7",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 5,
    y: 9,
    fill: "#D4D7E6",
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 5,
    fill: "#B1B4C7",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 5,
    y: 9,
    fill: "#D4D7E6",
    rx: 2.5
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 136)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 17,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 17,
    y: 96,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 209,
    fill: "#BC4747",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 24,
    x: 209,
    y: 32,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 24,
    x: 87,
    y: 31.547,
    fill: "#BC4747",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 24,
    x: 247,
    y: 64.53,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 24,
    y: 63.925,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 305,
    y: 32,
    fill: "#BC4747",
    rx: 12
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 5,
    fill: "#CBCEDC",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 26)",
    fill: "#8C90A3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 19,
    rx: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 19,
    x: 76,
    y: 0.288,
    rx: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 19,
    x: 115,
    rx: 9.5
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353740",
    d: "M0 0h107v397H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 5,
    y: 68,
    fill: "#4A4E5D",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 5,
    y: 87,
    fill: "#4A4E5D",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 5,
    y: 106,
    fill: "#4A4E5D",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 5,
    y: 125,
    fill: "#4A4E5D",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 5,
    y: 144,
    fill: "#4A4E5D",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 5,
    y: 366,
    fill: "#4A4E5D",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 5,
    fill: "#7B7F90",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 5,
    y: 9,
    fill: "#4A4E5D",
    rx: 2.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#FF5E5E"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 9,
    fill: "#8C90A3",
    rx: 4.5
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#4A5166",
    fillRule: "nonzero",
    opacity: 0.098,
    transform: "translate(387 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.64,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.68,
    height: 4,
    x: 19.32,
    rx: 1.84
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 430)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#242942",
    fillRule: "nonzero",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 126.689,
    height: 57.968,
    x: 324.47,
    y: -46.564,
    fill: "#2E334F",
    fillRule: "nonzero",
    mask: "url(#f)",
    rx: 10
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C27",
    fillRule: "nonzero",
    d: "M0 448h776a7 7 0 01-7 7H7a7 7 0 01-7-7z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(44 9.21)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#g)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#242942",
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EBEDF4",
    fillRule: "nonzero",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353740",
    d: "M0 0h155v77H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 293 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 17,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 17,
    y: 96,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 209,
    fill: "#BC4747",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 24,
    x: 209,
    y: 32,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 24,
    x: 87,
    y: 31.547,
    fill: "#BC4747",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 24,
    x: 247,
    y: 64.53,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 24,
    y: 63.925,
    fill: "#FF5E5E",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 305,
    y: 32,
    fill: "#BC4747",
    rx: 12
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 47,
    x: 8,
    y: 52,
    fill: "#FFF",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 5,
    x: 37,
    y: 21,
    fill: "#4A4E5D",
    rx: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74 85)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 5,
    fill: "#B1B4C7",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 5,
    y: 9,
    fill: "#D4D7E6",
    rx: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDevices);
export default __webpack_public_path__ + "static/media/illustration-devices.30f970328fa2963777660c23d307ba6d.svg";
export { ForwardRef as ReactComponent };